import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=2b6581a1&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=2b6581a1&scoped=true&lang=css&"
import style1 from "./Main.vue?vue&type=style&index=1&id=2b6581a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6581a1",
  null
  
)

export default component.exports